import { motion } from "framer-motion";
import { HourglassMedium } from "@phosphor-icons/react";

export function InitializingState({ displayName }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="min-h-[70vh] flex flex-col items-center justify-center text-center" data-testid="client-initializing-state">
      <HourglassMedium size={48} weight="duotone" className="text-igc-goldText mb-6 animate-pulse" />
      <h1 className="font-serif text-3xl text-igc-cream mb-3">Welcome, {displayName}</h1>
      <p className="text-igc-goldText tracking-widest uppercase text-sm mb-2">Store Initializing</p>
      <p className="text-igc-muted max-w-md">Coming Online Soon — IGC's proprietary platform is preparing your store for launch. You'll be notified the moment your dashboard goes live.</p>
    </motion.div>
  );
}
